<app-page [title]="title" padding="0" [info]="pageInfo">
  <div top-right>
    <ng-content select="[top-right]"></ng-content>
    <app-button [matMenuTriggerFor]="topRightMenu" class="mb-1" color="primary" icon="more_vert" *ngIf="canDelete"></app-button>
    <mat-menu #topRightMenu="matMenu">
      <app-button *ngIf="crud" (click)="onDeleteClick()" [disabled]="!canDelete" label="Elimina" icon="delete" color="warn"></app-button>
      <div #refMenuActions>
        <ng-content select="[menu-actions]"></ng-content>
      </div>
    </mat-menu>
  </div>
  <div class="page-detail p-0">
    <div class="flex w-12">
      <ng-content select="[header]"></ng-content>
    </div>
    <div class="page-detail-content">
      <ng-content></ng-content>
    </div>
  </div>
  <div footer>
    <div class="flex w-12">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</app-page>
